import React from "react";
import classes from "./Navbar.module.css";
import { Link, useNavigate } from "react-router-dom";

const Navbar = (props) => {
  const navigate = useNavigate();
  return (
    <div className={classes.nav}>
      <span
        onClick={() => {
          navigate("/");
        }}
        className={classes.title}
      >
        Mert Karaca
      </span>
      <div className={classes.linkContainer}>
        <Link
          to="/"
          style={{
            borderBottom: props.onPage === "Home" ? "2px solid #b5964d" : null,
          }}
        >
          <span>About Me</span>
        </Link>
        <Link
          to="/Projects"
          style={{
            borderBottom:
              props.onPage === "Projects" ? "2px solid #b5964d" : null,
          }}
        >
          <span>Projects</span>
        </Link>
        <a
          onClick={() => {
            window.location = "mailto:izm.mertkaraca@hotmail.com";
          }}
        >
          <span>Contact</span>
        </a>

        {/* <a href="Mert_Karaca_CV.pdf" download>
          <span>Resume</span>
        </a>
        <a href="#footer">
          <span>Social</span>
        </a> */}
      </div>
    </div>
  );
};

export default Navbar;
